// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WgIrY","field":"styles_field__3pdEH","fieldCol":"styles_fieldCol__K2II7","diffCol":"styles_diffCol__Is3cz","diff":"styles_diff__2l2X-"};